import { render } from "./VideoEdit.vue?vue&type=template&id=194bc4a0&scoped=true&ts=true"
import script from "./VideoEdit.vue?vue&type=script&lang=ts"
export * from "./VideoEdit.vue?vue&type=script&lang=ts"

import "./VideoEdit.vue?vue&type=style&index=0&id=194bc4a0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194bc4a0"]])

export default __exports__